import { TrackingInput } from "../types";

export const trackingInput: TrackingInput = {
    search: {
        label: 'general.searchUsers',
        translate: true,
        name: 'search',
        value: null,
    },
    area: {
        label: 'general.tags.area',
        translate: true,
        name: 'area',
        type: 'filter-select',
        items: [],
        value: null,
    },
    department: {
        label: 'general.tags.department',
        translate: true,
        name: 'department',
        type: 'filter-select',
        items: [],
        value: null,
    },
    userType: {
        label: 'general.tags.userType',
        translate: true,
        name: 'userType',
        type: 'filter-select',
        items: [],
        value: null,
    },
    // from: {
    //     label: 'general.tags.from',
    //     translate: true,
    //     name: 'from',
    //     type: 'date',
    //     value: null,
    //     rest: {
    //         max: 'to',
    //     },
    //     size: {
    //         xl: 6,
    //         lg: 6,
    //         md: 6,
    //         sm: 6,
    //         xs: 6,
    //     },
    // },
    // to: {
    //     label: 'general.tags.to',
    //     translate: true,
    //     name: 'to',
    //     type: 'date',
    //     value: null,
    //     rest: {
    //         min: 'from',
    //     },
    //     size: {
    //         xl: 6,
    //         lg: 6,
    //         md: 6,
    //         sm: 6,
    //         xs: 6,
    //     },
    // },
    role: {
        label: 'general.tags.role',
        translate: true,
        name: 'role',
        type: 'filter-select',
        items: [],
        value: null,
    },
    // stores: {
    //     label: 'general.tags.store',
    //     translate: true,
    //     name: 'stores',
    //     type: 'filter-select',
    //     items: [],
    //     value: null,
    // },
    // division_ids: {
    //     label: 'general.tags.divisions',
    //     translate: true,
    //     name: 'division_ids',
    //     type: 'filter-select',
    //     items: [],
    //     value: null,
    // },
}